import { getSessionDuration } from 'application/session_duration'

export function clickLinkEvent(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "click_link",
    session_duration: getSessionDuration(),
    module_name: data.module_name,
    click_text: data.click_text,
    link_url: data.link_url,
    link_type: data.link_type
  });
}
